<template>
  <div>
    <CModal title="Tạo phiếu nhập" :show.sync="showForm" :closeOnBackdrop="false">
      <p>
        Phiếu nhập gồm các sim của lô <strong>{{ lotName }}</strong> chưa có phiếu nhập hoàn thành
        và chưa nằm trên phiếu nháp.
      </p>
      <BaseSelect :options="warehouseSelect.options" :data="warehouseSelect.data" />
      <BaseSelect :options="purposeSelect.options" :data="purposeSelect.data" />
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="showForm = false">Hủy bỏ</button>
        <button type="button" class="btn btn-primary" :disabled="loading.value" @click="createSlip">Tạo phiếu</button>
      </template>
    </CModal>
    <CModal title="Phiếu nhập" :show.sync="showAsk" :closeOnBackdrop="false">
      <p>
        Đã tạo phiếu nhập <strong>{{ documentNo }}</strong> với {{ simCount }} sim.
      </p>
      <p>Bạn có muốn xem phiếu nhập?</p>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="showAsk = false">Không</button>
        <button type="button" class="btn btn-primary" @click="openSlip">Có</button>
      </template>
    </CModal>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";

export default {
  name: "SimQuickImport",
  components: { BaseSelect },
  notifications: {
    showSuccessMsg: { type: "success", title: "Success" },
    showErrorMsg: { type: "error", title: "Error" }
  },
  data() {
    let that = this;
    return {
      loading: { value: false },
      showForm: false,
      showAsk: false,
      lotId: null,
      lotName: "",
      stockId: null,
      documentNo: "",
      simCount: 0,
      warehouseSelect: {
        options: {
          filter: true,
          label: "Kho <span class='required'>*</span>",
          selectAllText: "Chọn kho",
          keyField: "value",
          valueField: "text"
        },
        data: {
          name: "warehouseId",
          items: [],
          model: "",
          source: {
            url: "/warehouse/list-warehouse",
            dataSubmit: function () {
              return {};
            },
            response: function (dataResponse) {
              that.warehouseSelect.data.items = dataResponse.data;
            }
          }
        }
      },
      purposeSelect: {
        options: {
          filter: false,
          label: "Phân loại phiếu <span class='required'>*</span>",
          selectAllText: "Chọn phân loại"
        },
        data: {
          name: "purpose",
          items: [
            { key: "new", value: "Nhập mới" },
            { key: "guarantee", value: "Nhập lại hàng sửa chữa" }
          ],
          model: "new"
        }
      }
    };
  },
  methods: {
    open(lot) {
      this.lotId = lot && lot.id;
      this.lotName = lot && lot.name ? lot.name : "";
      this.warehouseSelect.data.model = "";
      this.purposeSelect.data.model = "new";
      this.showForm = true;
    },
    createSlip() {
      let that = this;
      if (!this.warehouseSelect.data.model) {
        this.showErrorMsg({ message: "Chọn kho" });
        return;
      }
      if (this.purposeSelect.data.model !== "new" && this.purposeSelect.data.model !== "guarantee") {
        this.showErrorMsg({ message: "Chọn phân loại phiếu" });
        return;
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/sim/create-import",
        dataSubmit: function () {
          return {
            lotId: that.lotId,
            warehouseId: that.warehouseSelect.data.model,
            purpose: that.purposeSelect.data.model
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            return;
          }
          const data = response.data.data || {};
          that.stockId = data.id;
          that.documentNo = data.documentNo || "";
          that.simCount = data.simCount || 0;
          that.showForm = false;
          that.showAsk = true;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    openSlip() {
      this.showAsk = false;
      if (this.stockId) {
        this.$router.push("/stock-management/" + this.stockId + "/update.html");
      }
    }
  }
};
</script>
